import React from "react";
import { Link } from "react-router-dom";

export const TournamentLinkColumnFormatter = (cellContent, row, rowIndex, {dIndexName}) => (
    // console.log('row', row),
    // console.log('dIndexName', dIndexName),
    // console.log('row[dIndexName]', row['_id']),    
    dIndexName ? <Link to={`/tournaments/gamerji/view/${row['_id']}`} target="_blank">{row['_id']}</Link>  : '-' 
);
// app-user/profile/618e5c1d3ec5607c108e7e7d/profile-overview